<template>
  <a-spin :spinning="spinning" size="large">
    <div class="post-detail">
      <template v-if="!!detailList && !!detailList.company">
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col gap">
            <span class="title">{{ detailList.name }}</span>
            <span
              class="ji"
              :class="[detailList.is_urgent == '0' ? 'hide' : 'show']"
              >急</span
            >
            <span
              class="hc"
              :class="[detailList.is_mhc == '0' ? 'hide' : 'show']"
              >多HC</span
            >
          </a-col>
          <a-col class="col col2">
            <span>
              <!-- <icon-font type="riqi" /> -->
              职位状态：
              <span class="red">
                {{
                  detailList.status == "DRAFT"
                    ? "草稿"
                    : detailList.status == "PENDING"
                    ? "待审核"
                    : detailList.status == "OK"
                    ? "正常"
                    : detailList.status == "PAUSED"
                    ? "暂停"
                    : detailList.status == "BLOCKED"
                    ? "禁用"
                    : null
                }}
              </span>
            </span>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <span class="salary"
              >{{ detailList.hunter_salary_min }}—{{
                detailList.hunter_salary_max
              }}万</span
            >
            <a-divider type="vertical" />
            <span>{{ detailList.city_name }}</span>
            <a-divider type="vertical" />
            <span>招聘{{ detailList.quantity }}人</span>
            <a-divider type="vertical" />
            <span>{{ detailList.experience_name }}</span>
            <a-divider type="vertical" />
            <span>{{ detailList.education_name }}</span>
          </a-col>
          <a-col class="">
            <span class="time">
              更新时间：<span>{{ detailList.company.updated_at }}</span>
            </span>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <span>{{ detailList.company.name }}</span>
          </a-col>
          <a-col class="col col2">
            <span
              >被浏览：<span class="blue">{{ detailList.num_views }}</span>
              人</span
            >
            <span class="gap2"
              >已接单：<span class="blue">{{ detailList.count_posts }}</span>
              个</span
            >
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <span></span>
          </a-col>
          <a-col class="col">
            <a-dropdown placement="bottomCenter">
              <a @click.stop key="1">
                <!-- <img src="../../assets/ico-share.png" style="width:17px" alt />分享 -->
              </a>
              <div slot="overlay" class="overlay-post">
                <!-- <img :src="`${baseURL}/job/createJobQr?job_id=${detail.id}`" alt /> -->
                <p>微信扫一扫分享</p>
              </div>
            </a-dropdown>
            <a @click.prevent>
              <!-- <img src="../../assets/ico-request.png" style="width:20px" alt />咨询 -->
            </a>
          </a-col>
        </a-row>
        <a-row
          class="row theme"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <a-col class="col">
            <a-row>
              <!-- 猎头职位 -->
              <a-col>
                <a-row type="flex" align="middle">
                  <a-col>
                    <icon-font
                      type="xuanshangjine"
                      :style="{
                        color: '#F6B502',
                        fontSize: '20px',
                        marginRight: '5px'
                      }"
                    ></icon-font>
                  </a-col>
                  <!-- 比例佣金 -->
                  <template>
                    <a-col>
                      预计佣金{{ detailList.hunter_commission_min }}-{{
                        detailList.hunter_commission_max
                      }}， 保证期
                      {{
                        detailList.probation == "0"
                          ? ""
                          : detailList.probation == "1"
                          ? "1个月"
                          : detailList.probation == "2"
                          ? "2个月"
                          : detailList.probation == "3"
                          ? "3个月"
                          : detailList.probation == "4"
                          ? "6个月"
                          : detailList.probation == "5"
                          ? "6个月或以上"
                          : null
                      }}
                    </a-col>
                  </template>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <!-- tabs -->
        <a-tabs class="tabs" :defaultActiveKey="tab">
          <a-tab-pane tab="已授权简历" :key="1">
            <cloud
              :id="post_id"
              :jobname="jobname"
              :jobid="jobid"
              :authStatus="authStatus"
              :jobStatus="detail.status"
              :jobDetail="detail"
            ></cloud>
          </a-tab-pane>
          <a-tab-pane tab="职位信息" :key="2" forceRender>
            <info :info="detail" type="job"></info>
          </a-tab-pane>
          <a-tab-pane tab="职位备注" :key="3" forceRender>
            <info :info="detail" type="notice"></info>
          </a-tab-pane>
          <a-tab-pane tab="公司信息" :key="4" forceRender>
            <info :info="detail.company" type="company"></info>
          </a-tab-pane>
          <a-tab-pane tab="案情通告" :key="5">
            <post-dynamic :id="post_id"></post-dynamic>
          </a-tab-pane>
          <a-tab-pane tab="职位评级" :key="6">
            <info :info="detail" type="level"></info>
          </a-tab-pane>
        </a-tabs>
      </template>
    </div>
  </a-spin>
</template>

<script>
import Api from "@/api";
import Cloud from "./detail/cloud.vue";
import PostDynamic from "./detail/postDynamic";
import Info from "./detail/info";
// import Qa from "./detail/q&a";
export default {
  name: "postDetail",
  data() {
    return {
      detail: null,
      spinning: false,
      detailList: [],
      jobname: undefined,
      jobid: undefined
    };
  },
  props: {
    id: {
      default: -1
    },
    tab: {
      type: Number,
      default: 1
    },
    authStatus: {
      type: String,
      default: "0"
    }
  },
  // draggable: { Cloud },
  components: { Cloud, Info, PostDynamic },
  computed: {
    post_id() {
      if (this.id < 0) {
        return this.$route.params.id;
      } else {
        return this.id;
      }
    }
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.spinning = true;
      let response = await Api.position.getDetail({ job_id: this.post_id });
      if (response) {
        this.jobname = response.job.name;
        this.jobid = response.job.id;
        this.spinning = false;
        this.detailList = response.job;
        this.detail = response.job;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.post-detail {
  // max-width: 1250px;
  margin: 0 auto;
  min-height: 400px;
  padding-top: 40px;
  .row {
    margin-bottom: 10px;
    &.theme {
      padding: 0 20px;
      margin: 20px 0;
      height: 46px;
      background: rgba(53, 181, 254, 0.1);
      border: 1px solid rgba(53, 181, 254, 1);
    }
    .col {
      display: flex;
      align-items: center;
      .gap2 {
        margin-left: 16px;
      }
      span {
        // display: flex;
        align-items: center;
        &.title {
          font-size: 16px;
          font-weight: bold;
        }
        &.ji {
          font-size: 12px;
          background: #ff6b5d;
          border-radius: 2px;
          height: 18px;
          color: #fff;
          padding: 0 3px;
          margin: 0 5px;
        }
        .hide {
          display: none;
        }
        .show {
          display: inline-block;
        }
        &.hc {
          background: #f6b502;
          padding: 0 3px;
          font-size: 12px;
          border-radius: 2px;
          height: 18px;
          color: #fff;
        }
        &.time {
          color: #999;
          .anticon {
            margin-right: 5px;
            font-size: 16px;
          }
        }
        &.salary {
          font-size: 16px;
          color: #fc5646;
        }
        .anticon {
          font-size: 18px;
          margin-right: 5px;
        }
      }
      a {
        display: inline-block;
        margin-left: 20px;
        img {
          margin-right: 5px;
        }
      }
      .ant-btn {
        margin-left: 20px;
      }
    }
  }
  .tabs {
    .ant-tabs-tab {
      font-weight: bold;
      color: #303133;
    }
  }
  .red {
    color: red;
  }
}
</style>
